import { render, staticRenderFns } from "./link-form.vue?vue&type=template&id=0ab6447d&"
import script from "./link-form.vue?vue&type=script&lang=js&"
export * from "./link-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports